import { Injectable, signal } from '@angular/core';
import { IBrand } from '../../shared/interfaces/brand';

@Injectable({
  providedIn: 'root'
})
export class SharedSignalService {

  private envRegionSignal = signal<string>('');
  private brandCodeSignal = signal<string>('');
  private brandProfileSignal = signal(<IBrand> {});
  private hasEnrollmentSimulatorSignal = signal<boolean>( false);
  private passwordRecoveryPhaseSignal = signal<string>('');

  readonly envRegion = this.envRegionSignal.asReadonly();
  readonly brandCode = this.brandCodeSignal.asReadonly();
  readonly brandProfile = this.brandProfileSignal.asReadonly();
  readonly hasEnrollmentSimulator = this.hasEnrollmentSimulatorSignal.asReadonly();
  // readonly passwordRecoveryPhase = this.passwordRecoveryPhaseSignal.asReadonly();

  constructor() { }

  setEnvRegion(envRegion: string) {
    this.envRegionSignal.set(envRegion);
  }

  setBrandCode(brandCode: string) {
    this.brandCodeSignal.set(brandCode);
  }

  setBrandProfile(brandProfile: IBrand) {
    this.brandProfileSignal.set(brandProfile);
  }

  setHasEnrollmentSimulator(hasEnrollmentSimulator: boolean) {
    this.hasEnrollmentSimulatorSignal.set(hasEnrollmentSimulator);
  }

  getPasswordRecoveryPhase() {
    return this.passwordRecoveryPhaseSignal();
  } 

  setPasswordRecoveryPhase(recoveryPhase: string) {
    this.passwordRecoveryPhaseSignal.set(recoveryPhase);
  }  

}
